<nx-message id={{id}} nxContext="{{messageContext}}" style="width: fit-content;">
    {{message}}
</nx-message>